module.exports = __webpack_public_path__ + "img/qq10.36b155bf.jpg";